export default __webpack_public_path__ + "static/media/landing-mobile.35d00962.jpg";